import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AnimationOptions } from 'ngx-lottie';
import { opacityInOutSlow } from '../../animations/scale-in-out-slow.animation';
import { opacityInOut } from '../../animations/opacity-in-out.animation';

@Component({
  selector: 'lottie-loader',
  templateUrl: 'lottie-loader.component.html',
  styleUrls: ['lottie-loader.component.scss'],
  animations: [ opacityInOut, opacityInOutSlow ]
})
export class LottieLoaderComponent {

  @Input() set visibility(val) {
    if (val) {
      setTimeout(() => this.visible = true, 200);
      setTimeout(() => this.textVisible = true, 300);
    } else {
      this.textVisible = false;
      setTimeout(() => this.visible = false, 500);
    }
  };
  @Input() msg = null;
  visible = false;
  textVisible = false;
  isBrowser: boolean;
  options: AnimationOptions = {    
    path: 'https://res.cloudinary.com/dteo0axta/raw/upload/v1686651880/assets/loader-space-final_zwztr7.json'  
  };

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

}
